import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../hooks/useAutofillEvent.css';
import './BaseInput.css';
import './BaseInputContent.css';
export var content = '_o6rxr70-3-5-0 _da9a8v0-3-5-0 _da9a8v2-3-5-0 _da9a8v3-3-5-0 _da9a8vb-3-5-0';